export function getCodeForm(aa) {
    if (aa && aa.name) {
        if (aa.name.startsWith("4457") && aa.vatRate) {
            switch (aa.vatRate) {
                case 20:
                    return "08";
                case 5.5:
                    return "09";
                case 10:
                    return "9B";
                case 8.5:
                    return "10";
                case 2.1:
                    return "11";
            }
        }
        if (aa.name.startsWith("4452")) {
            return "17";
        }
        if (aa.name.startsWith("44551")) {
            return "28";
        }
        if (aa.name.startsWith("44562")) {
            return "19";
        }
        if (aa.name.startsWith("44566")) {
            return "20";
        }
        if (aa.name.startsWith("44567")) {
            return "22";
        }
    }
    debugger;
    return "";
}

export function fillVatAccountableAccountAttributes(accountableAccount: any): any {
    accountableAccount.type = "ThirdParty";
    if (defaultDedVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA sur autres biens et services";
        accountableAccount.vatRate = null;
        accountableAccount.vatType = null;
        accountableAccount.vatOperationType = "PURCHASE";
    } else if (defaultFixedAssetsVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA sur immobilisations";
        accountableAccount.vatRate = null;
        accountableAccount.vatType = null;
        accountableAccount.vatOperationType = "PURCHASE_FIXED_ASSET";
    } else if (defaultCollVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA collectée 20%";
        accountableAccount.vatRate = 20;
        accountableAccount.vatType = null;
        accountableAccount.vatOperationType = "SALE";
    } else if (salesIntracomDedVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA déductible sur livraisons intracommunautaires";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "INTRACOM_DEBIT";
        accountableAccount.vatOperationType = "SALE";
    } else if (salesIntracomCollVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA due sur livraisons intracommunautaires";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "INTRACOM_CREDIT";
        accountableAccount.vatOperationType = "SALE";
    } else if (purchasesIntracomDedVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA déductible sur acquisition intracommunautaires";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "INTRACOM_DEBIT";
        accountableAccount.vatOperationType = "PURCHASE";
    } else if (purchasesIntracomCollVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA due intracommunautaire";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "INTRACOM_CREDIT";
        accountableAccount.vatOperationType = "PURCHASE";
    } else if (purchasesReverseChargeDedVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "Taxes assimilées à la TVA autoliquidation";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "REVERSE_CHARGE_DEBIT";
        accountableAccount.vatOperationType = "PURCHASE";
    } else if (purchasesReverseChargeCollVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "Taxes assimilées à la TVA autoliquidation";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "REVERSE_CHARGE_CREDIT";
        accountableAccount.vatOperationType = "PURCHASE";
    } else if (purchasesImportDedVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA import";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "IMPORT_DEBIT";
        accountableAccount.vatOperationType = "PURCHASE";
    } else if (purchasesImportCollVatAANameList.includes(accountableAccount.name)) {
        accountableAccount.description = "TVA due import";
        accountableAccount.vatRate = 0;
        accountableAccount.vatType = "IMPORT_CREDIT";
        accountableAccount.vatOperationType = "PURCHASE";
    }
}

// get ... from ...

export function getVatRateFromAAName(vatAAs: any[], aaName: string) {
    let vatAA = null;
    if (vatAAs && vatAAs.length) {
        vatAA = vatAAs.find((aa) => aa.name === aaName);
        if (vatAA) {
            return vatAA.vatRate;
        }
    }
    // debugger
    return null;
}

// export function getVatRateAndTypeFromAAName(vatAAs: any[], aaName: string) {
//     let vatAA = null
//     if (vatAAs && vatAAs.length) {
//         vatAA = vatAAs.find(aa => aa.name === aaName)
//         if (vatAA) {
//             return { vatRate: vatAA.vatRate, vatType: vatAA.vatType }
//         }
//     }
//     // debugger
//     return { vatRate: null, vatType: null }
// }

export function getAANameFromVatRate(vatAAs: any[], aaNamePrefix: string, vatRate: number): string {
    const AAFromVatRate = vatAAs?.find(
        (aa) => aa.name.startsWith(aaNamePrefix) && aa.vatRate === vatRate
    );
    if (AAFromVatRate) {
        return AAFromVatRate?.name;
    }
    debugger;
    return "471000";
}

export function getAANamesFromVatRate(
    vatAAs: any[],
    aaNamePrefix: string,
    vatRate: number
): string[] {
    const AAsFromVatRate = vatAAs?.filter(
        (aa) => aa.name.startsWith(aaNamePrefix) && aa.vatRate === vatRate
    );
    // return AAsFromVatRate?.map(aa => aa.name) || ["471000"]
    if (AAsFromVatRate) {
        return AAsFromVatRate?.map((aa) => aa.name);
    }
    debugger;
    return ["471000"];
}

export function getAANameFromVatType(vatAAs: any[], aaNamePrefix: string, vatType: string): string {
    const AAFromVatType = vatAAs?.find(
        (aa) => aa.name.startsWith(aaNamePrefix) && aa.vatType === vatType
    );
    // return AAFromVatType?.name || "471000"
    if (AAFromVatType) {
        return AAFromVatType?.name;
    }
    debugger;
    return "471000";
}

export function getAANameFromVatRateAndVatType(
    vatAAs: any[],
    aaNamePrefix: string,
    vatRate: number,
    vatType: string
): string {
    const AAFromVatRateAndVatType = vatAAs?.find(
        (aa) =>
            aa.name.startsWith(aaNamePrefix) &&
            aa.vatRate === vatRate &&
            (aa.vatRate || aa.vatType === vatType)
    );
    if (AAFromVatRateAndVatType) {
        return AAFromVatRateAndVatType?.name;
    }
    debugger;
    return "471000";
    // return AAFromVatRateAndVatType?.name || "471000"
}

// "déductible" & "collectée"

const defaultDedVatAANameList = [
    "445660",
    "445661",
    "445663",
    "445664",
    "445665",
    "445666",
    "445667",
    "445668",
];

export function getDefaultDedVatAAName(vatAAs: any[]): string {
    let defaultDedVatAAName = "";
    if (vatAAs && vatAAs.length) {
        defaultDedVatAAName = vatAAs.find(
            (aa) =>
                aa.name.startsWith("44566") &&
                aa.vatOperationType === "PURCHASE" &&
                aa.vatType === null
        )?.name;
        if (defaultDedVatAAName) {
            return defaultDedVatAAName;
        }
    }

    //  else {
    //     for (const aaName of defaultDedVatAANameList) {
    //         if (!vatAAs.some(aa => aa.name === aaName)) {
    //             return aaName
    //         }
    //     }
    //     return "471000"
    // }
    debugger;
    return "445660";
}

export function getDedVatAANames(vatAAs: any[]): string[] {
    let dedVatAANames = [];
    if (vatAAs && vatAAs.length) {
        dedVatAANames = vatAAs
            .filter(
                (aa) =>
                    aa.name.startsWith("4456") &&
                    aa.vatOperationType === "PURCHASE" &&
                    aa.vatRate === null
            )
            ?.map((aa) => aa.name);
    }
    if (!dedVatAANames.length) {
        debugger;
    }
    return dedVatAANames;
}

const defaultFixedAssetsVatAANameList = [
    "445620",
    "445621",
    "445622",
    "445623",
    "445624",
    "445625",
    "445626",
    "445627",
    "445628",
];

export function getDefaultFixedAssetsVatAAName(vatAAs: any[]): string {
    let defaultFixedAssetsVatAAName = "";
    if (vatAAs && vatAAs.length) {
        defaultFixedAssetsVatAAName = vatAAs.find(
            (aa) => aa.name.startsWith("445") && aa.vatOperationType === "PURCHASE_FIXED_ASSET"
        )?.name;
    }
    if (defaultFixedAssetsVatAAName) {
        return defaultFixedAssetsVatAAName;
    }
    for (const aaName of defaultFixedAssetsVatAANameList) {
        if (!vatAAs.some((aa) => aa.name === aaName)) {
            return aaName;
        }
    }
    return "471000";
}

export function getFixedAssetsVatAANames(vatAAs: any[]): string[] {
    let fixedAssetsVatAANames = [];
    if (vatAAs && vatAAs.length) {
        fixedAssetsVatAANames = vatAAs
            .filter(
                (aa) => aa.name.startsWith("445") && aa.vatOperationType === "PURCHASE_FIXED_ASSET"
            )
            ?.map((aa) => aa.name);
    }
    return fixedAssetsVatAANames;
}

const defaultCollVatAANameList = [
    "445720",
    "445721",
    "445722",
    "445723",
    "445724",
    "445725",
    "445726",
    "445727",
    "445728",
];

export function getDefaultCollVatAAName(vatAAs: any[]): string {
    if (vatAAs && vatAAs.length) {
        const defaultCollVatAAName = vatAAs.find(
            (aa) =>
                aa.name.startsWith("4457") && aa.vatOperationType === "SALE" && aa.vatRate === 20
        )?.name;
        if (defaultCollVatAAName) {
            return defaultCollVatAAName;
        }
    }
    for (const aaName of defaultCollVatAANameList) {
        if (!vatAAs.some((aa) => aa.name === aaName)) {
            return aaName;
        }
    }
    debugger;
    return "471000";
}

export function getAllDedVatAANames(vatAAs: any[]): string[] {
    if (vatAAs) {
        const standardDedVatAANames = [
            ...getDedVatAANames(vatAAs),
            ...getFixedAssetsVatAANames(vatAAs),
        ];
        const dedOnSalesVatAA = vatAAs.find(
            (aa) =>
                aa.name.startsWith("4456") &&
                aa.vatOperationType === "SALE" &&
                aa.vatType !== "INTRACOM_DEBIT" &&
                aa.vatRate === null
        );
        if (dedOnSalesVatAA) {
            return [...standardDedVatAANames, dedOnSalesVatAA.name];
        } else {
            return standardDedVatAANames;
        }
    }
    debugger;
    return ["445620", "445660", "445600"];
}

export function getCollVatAANames(vatAAs: any[]): string[] {
    const collVatAAs = vatAAs?.filter(
        (aa) => aa.name.startsWith("4457") && aa.vatRate > 0 && aa.vatOperationType === "SALE"
    );
    return collVatAAs?.map((aa) => aa.name) || ["445702", "445705", "445708", "445710", "445720"];
}

export function getImportAANames(vatAAs: any[]): string[] {
    const importAAs = vatAAs?.filter((aa) => aa.vatType && aa.vatType.includes("IMPORT"));
    return importAAs?.map((aa) => aa.name) || ["445630", "445730"];
}

// intracom

const salesIntracomDedVatAANameList = ["445663", "445664", "445665", "445666", "445667", "445668"];

export function getDefaultSalesIntracomDedVatAAName(vatAAs: any[]): string {
    if (vatAAs && vatAAs.length) {
        const salesIntracomDedVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "SALE" && aa.vatType === "INTRACOM_DEBIT"
        )?.name;
        if (salesIntracomDedVatAAName) {
            return salesIntracomDedVatAAName;
        }
    }

    for (const aaName of salesIntracomDedVatAANameList) {
        if (!vatAAs.some((aa) => aa.name === aaName)) {
            return aaName;
        }
    }
    debugger;
    return "471000";
}

export function getSalesIntracomDedVatAANames(vatAAs: any[]): string[] {
    let salesIntracomDedVatAANames = [];
    if (vatAAs && vatAAs.length) {
        salesIntracomDedVatAANames = vatAAs
            .filter((aa) => aa.vatOperationType === "SALE" && aa.vatType === "INTRACOM_DEBIT")
            ?.map((aa) => aa.name);
    }
    return salesIntracomDedVatAANames;
}

const salesIntracomCollVatAANameList = ["445300", "445400", "445500", "445600", "445700", "445800"];

export function getDefaultSalesIntracomCollVatAAName(vatAAs: any[]): string {
    let salesIntracomCollVatAAName = "";
    if (vatAAs && vatAAs.length) {
        salesIntracomCollVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "SALE" && aa.vatType === "INTRACOM_CREDIT"
        )?.name;
    }
    if (salesIntracomCollVatAAName) {
        return salesIntracomCollVatAAName;
    } else {
        for (const aaName of salesIntracomCollVatAANameList) {
            if (!vatAAs.some((aa) => aa.name === aaName)) {
                return aaName;
            }
        }
        return "471000";
    }
}

export function getSalesIntracomCollVatAANames(vatAAs: any[]): string[] {
    let salesIntracomCollVatAANames = [];
    if (vatAAs && vatAAs.length) {
        salesIntracomCollVatAANames = vatAAs
            .filter((aa) => aa.vatOperationType === "SALE" && aa.vatType === "INTRACOM_CREDIT")
            ?.map((aa) => aa.name);
    }
    return salesIntracomCollVatAANames;
}

const purchasesIntracomDedVatAANameList = [
    "445662",
    "445663",
    "445664",
    "445665",
    "445666",
    "445667",
    "445668",
];

export function getDefaultPurchasesIntracomDedVatAAName(vatAAs: any[]): string {
    let purchasesIntracomDedVatAAName = "";
    if (vatAAs && vatAAs.length) {
        purchasesIntracomDedVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "INTRACOM_DEBIT"
        )?.name;
    }
    if (purchasesIntracomDedVatAAName) {
        return purchasesIntracomDedVatAAName;
    } else {
        for (const aaName of purchasesIntracomDedVatAANameList) {
            if (!vatAAs.some((aa) => aa.name === aaName)) {
                return aaName;
            }
        }
        return "471000";
    }
}

export function getPurchasesIntracomDedVatAANames(vatAAs: any[]): string[] {
    let purchasesIntracomDedVatAANames = [];
    if (vatAAs && vatAAs.length) {
        purchasesIntracomDedVatAANames = vatAAs
            .filter((aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "INTRACOM_DEBIT")
            ?.map((aa) => aa.name);
    }
    return purchasesIntracomDedVatAANames;
}

const purchasesIntracomCollVatAANameList = [
    "445200",
    "445300",
    "445400",
    "445500",
    "445600",
    "445700",
    "445800",
];

export function getDefaultPurchasesIntracomCollVatAAName(vatAAs: any[]): string {
    let purchasesIntracomCollVatAAName = "";
    if (vatAAs && vatAAs.length) {
        purchasesIntracomCollVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "INTRACOM_CREDIT"
        )?.name;
    }
    if (purchasesIntracomCollVatAAName) {
        return purchasesIntracomCollVatAAName;
    } else {
        for (const aaName of purchasesIntracomCollVatAANameList) {
            if (!vatAAs.some((aa) => aa.name === aaName)) {
                return aaName;
            }
        }
        return "471000";
    }
}

export function getPurchasesIntracomCollVatAANames(vatAAs: any[]): string[] {
    let purchasesIntracomCollVatAANames = [];
    if (vatAAs && vatAAs.length) {
        purchasesIntracomCollVatAANames = vatAAs
            .filter((aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "INTRACOM_CREDIT")
            ?.map((aa) => aa.name);
    }
    return purchasesIntracomCollVatAANames;
}

export function getIntracomSalesAANames(vatAAs: any[]): string[] {
    const salesIntracomDedVatAANames = getSalesIntracomDedVatAANames(vatAAs);
    const salesIntracomCollVatAANames = getSalesIntracomCollVatAANames(vatAAs);
    if (salesIntracomDedVatAANames && salesIntracomCollVatAANames) {
        return [...salesIntracomDedVatAANames, ...salesIntracomCollVatAANames];
    }
    debugger;
    return ["445300", "445663"];
}

export function getIntracomPurchasesAANames(vatAAs: any[]): string[] {
    const purchasesIntracomDedVatAANames = getPurchasesIntracomDedVatAANames(vatAAs);
    const purchasesIntracomCollVatAANames = getPurchasesIntracomCollVatAANames(vatAAs);
    if (purchasesIntracomDedVatAANames && purchasesIntracomCollVatAANames) {
        return [...purchasesIntracomDedVatAANames, ...purchasesIntracomCollVatAANames];
    }
    debugger;
    return ["445200", "445662"];
}

export function getIntracomVatAANames(vatAAs: any[]): string[] {
    const salesIntracomDedVatAANames = getSalesIntracomDedVatAANames(vatAAs);
    const salesIntracomCollVatAANames = getSalesIntracomCollVatAANames(vatAAs);
    const purchasesIntracomDedVatAANames = getPurchasesIntracomDedVatAANames(vatAAs);
    const purchasesIntracomCollVatAANames = getPurchasesIntracomCollVatAANames(vatAAs);
    if (
        salesIntracomDedVatAANames &&
        salesIntracomCollVatAANames &&
        purchasesIntracomDedVatAANames &&
        purchasesIntracomCollVatAANames
    ) {
        return [
            ...salesIntracomDedVatAANames,
            ...salesIntracomCollVatAANames,
            ...purchasesIntracomDedVatAANames,
            ...purchasesIntracomCollVatAANames,
        ];
    }
    debugger;
    return ["445300", "445663", "445200", "445662"];
}

// reverse charge

const purchasesReverseChargeDedVatAANameList = [
    "445680",
    "445681",
    "445682",
    "445683",
    "445684",
    "445685",
    "445686",
    "445687",
    "445688",
];

export function getDefaultPurchasesReverseChargeDedVatAAName(vatAAs: any[]): string {
    let purchasesReverseChargeDedVatAAName = "";
    if (vatAAs && vatAAs.length) {
        purchasesReverseChargeDedVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "REVERSE_CHARGE_DEBIT"
        )?.name;
    }
    if (purchasesReverseChargeDedVatAAName) {
        return purchasesReverseChargeDedVatAAName;
    } else {
        for (const aaName of purchasesReverseChargeDedVatAANameList) {
            if (!vatAAs.some((aa) => aa.name === aaName)) {
                return aaName;
            }
        }
        return "471000";
    }
}

export function getPurchasesReverseChargeDedVatAANames(vatAAs: any[]): string[] {
    let purchasesReverseChargeDedVatAANames = [];
    if (vatAAs && vatAAs.length) {
        purchasesReverseChargeDedVatAANames = vatAAs
            .filter(
                (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "REVERSE_CHARGE_DEBIT"
            )
            ?.map((aa) => aa.name);
    }
    return purchasesReverseChargeDedVatAANames;
}

const purchasesReverseChargeCollVatAANameList = [
    "445780",
    "445781",
    "445782",
    "445783",
    "445784",
    "445785",
    "445786",
    "445787",
    "445788",
];

export function getDefaultPurchasesReverseChargeCollVatAAName(vatAAs: any[]): string {
    let purchasesReverseChargeCollVatAAName = "";
    if (vatAAs && vatAAs.length) {
        purchasesReverseChargeCollVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "REVERSE_CHARGE_CREDIT"
        )?.name;
    }
    if (purchasesReverseChargeCollVatAAName) {
        return purchasesReverseChargeCollVatAAName;
    } else {
        for (const aaName of purchasesReverseChargeCollVatAANameList) {
            if (!vatAAs.some((aa) => aa.name === aaName)) {
                return aaName;
            }
        }
        return "471000";
    }
}

export function getPurchasesReverseChargeCollVatAANames(vatAAs: any[]): string[] {
    let purchasesReverseChargeCollVatAANames = [];
    if (vatAAs && vatAAs.length) {
        purchasesReverseChargeCollVatAANames = vatAAs
            .filter(
                (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "REVERSE_CHARGE_CREDIT"
            )
            ?.map((aa) => aa.name);
    }
    return purchasesReverseChargeCollVatAANames;
}

export function getReverseChargeAANames(vatAAs: any[]): string[] {
    const purchasesReverseChargeDedVatAANames = getPurchasesReverseChargeDedVatAANames(vatAAs);
    const purchasesReverseChargeCollVatAANames = getPurchasesReverseChargeCollVatAANames(vatAAs);
    if (purchasesReverseChargeDedVatAANames && purchasesReverseChargeCollVatAANames) {
        return [...purchasesReverseChargeDedVatAANames, ...purchasesReverseChargeCollVatAANames];
    }
    debugger;
    return ["445680", "445780"];
}

// import

const purchasesImportDedVatAANameList = [
    "445630",
    "445631",
    "445632",
    "445633",
    "445634",
    "445635",
    "445636",
    "445637",
    "445638",
];

export function getDefaultPurchasesImportDedVatAAName(vatAAs: any[]): string {
    let purchasesImportDedVatAAName = "";
    if (vatAAs && vatAAs.length) {
        purchasesImportDedVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "IMPORT_DEBIT"
        )?.name;
    }
    if (purchasesImportDedVatAAName) {
        return purchasesImportDedVatAAName;
    } else {
        for (const aaName of purchasesImportDedVatAANameList) {
            if (!vatAAs.some((aa) => aa.name === aaName)) {
                return aaName;
            }
        }
        return "471000";
    }
}

export function getPurchasesImportDedVatAANames(vatAAs: any[]): string[] {
    let purchasesImportDedVatAANames = [];
    if (vatAAs && vatAAs.length) {
        purchasesImportDedVatAANames = vatAAs
            .filter((aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "IMPORT_DEBIT")
            ?.map((aa) => aa.name);
    }
    return purchasesImportDedVatAANames;
}

const purchasesImportCollVatAANameList = [
    "445730",
    "445731",
    "445732",
    "445733",
    "445734",
    "445735",
    "445736",
    "445737",
    "445738",
];

export function getDefaultPurchasesImportCollVatAAName(vatAAs: any[]): string {
    let purchasesImportCollVatAAName = "";
    if (vatAAs && vatAAs.length) {
        purchasesImportCollVatAAName = vatAAs.find(
            (aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "IMPORT_CREDIT"
        )?.name;
    }
    if (purchasesImportCollVatAAName) {
        return purchasesImportCollVatAAName;
    } else {
        for (const aaName of purchasesImportCollVatAANameList) {
            if (!vatAAs.some((aa) => aa.name === aaName)) {
                return aaName;
            }
        }
        return "471000";
    }
}

export function getPurchasesImportCollVatAANames(vatAAs: any[]): string[] {
    let purchasesImportCollVatAANames = [];
    if (vatAAs && vatAAs.length) {
        purchasesImportCollVatAANames = vatAAs
            .filter((aa) => aa.vatOperationType === "PURCHASE" && aa.vatType === "IMPORT_CREDIT")
            ?.map((aa) => aa.name);
    }
    return purchasesImportCollVatAANames;
}

export function getImportVatAANames(vatAAs: any[]): string[] {
    const purchasesImportDedVatAANames = getPurchasesImportDedVatAANames(vatAAs);
    const purchasesImportCollVatAANames = getPurchasesImportCollVatAANames(vatAAs);
    if (purchasesImportDedVatAANames && purchasesImportCollVatAANames) {
        return [...purchasesImportDedVatAANames, ...purchasesImportCollVatAANames];
    }
    debugger;
    return ["445630", "445730"];
}

export function getImportAndIntracomAANames(vatAAs: any[]): string[] {
    const importAANames = getImportAANames(vatAAs);
    const intracomSalesAANames = getIntracomSalesAANames(vatAAs);
    const intracomPurchasesAANames = getIntracomPurchasesAANames(vatAAs);
    if (importAANames && intracomSalesAANames && intracomPurchasesAANames) {
        return [...importAANames, ...intracomSalesAANames, ...intracomPurchasesAANames];
    }
    debugger;
    return ["445630", "445730", "445200", "445300", "445662", "445663"];
}
